import React from "react";

// Custom.
import Permissions from "@vocollege/components/dist/Acl/Permissions";
import Layout from "containers/Layout/Layout";

const PermissionsPage: React.FC = () => {
  return (
    <Layout>
      <Permissions />
    </Layout>
  );
};

export default PermissionsPage;
